export default "__VITE_ASSET__BBSg1uQn__"